import {Record, List, OrderedMap} from 'immutable';

import {ColumnSetRecord} from './ColumnSetRecord';
import {ColumnRecord} from './ColumnRecord';

const logoHeight = (400 / 416) * 632;

const firstColumn = new ColumnRecord({height: logoHeight});
const otherColumn = new ColumnRecord();

export const COLUMNS = {
  ONE: 'ONE',
  TWO: 'TWO',
  THREE: 'THREE',
};

const DEFAULT_STATE = {
  noOfColumns: COLUMNS.THREE,
  images: new OrderedMap(),
  oneColumn: new ColumnSetRecord({columns: List.of(firstColumn)}),
  twoColumn: new ColumnSetRecord({columns: List.of(firstColumn, otherColumn)}),
  threeColumn: new ColumnSetRecord({columns: List.of(firstColumn, otherColumn, otherColumn)}),
};

const BaseRecord = Record(DEFAULT_STATE);

export class ImageStateRecord extends BaseRecord {
  get currentColumn() {
    switch (this.noOfColumns) {
      case COLUMNS.ONE: return this.oneColumn;
      case COLUMNS.TWO: return this.twoColumn;
      default: return this.threeColumn;
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/images/ImageStateRecord.js